import moment from 'moment';

import { BillStatementsQuery } from 'apollo/queries/autogenerate/operations';
import { BillStatementStatusV2 } from 'apollo/queries/autogenerate/schemas';

export const getOldestOutstandingBill = (
  data: BillStatementsQuery['billStatements'] | undefined
) => {
  if (data) {
    const outstandingBills = data.filter(
      ({ statusV2 }) => statusV2 === BillStatementStatusV2.OUTSTANDING
    );

    const sortedOutstandingBillStatements = sortBillsAscendingByDueDate(
      outstandingBills
    );

    return sortedOutstandingBillStatements[0];
  }
};

const sortBillsAscendingByDueDate = (
  billStatements: BillStatementsQuery['billStatements']
): BillStatementsQuery['billStatements'] =>
  [...billStatements].sort(
    (a, b) => moment(a?.dueAt).unix() - moment(b?.dueAt).unix()
  );
